import { render, staticRenderFns } from "./OsCustomerAssignedReportContentCategories.vue?vue&type=template&id=4a550398&scoped=true"
import script from "./OsCustomerAssignedReportContentCategories.vue?vue&type=script&lang=ts"
export * from "./OsCustomerAssignedReportContentCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a550398",
  null
  
)

export default component.exports